// extracted by mini-css-extract-plugin
export default {"handleBtns":"handleBtns-t74t3","btn":"btn-Pn9kp","prime":"prime-Ww5AN","round":"round-pC9kz"};